import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-med-reim-authorization-form',
  templateUrl: './med-reim-authorization-form.component.html',
  styleUrls: ['./med-reim-authorization-form.component.css']
})
export class MedReimAuthorizationFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/med-reim-authorization/med-reim-authorization-form/med-reim-authorization-form.component.ts